import { getApiBaseUrl } from "../../utils/apiBaseUrl";

export const DeleteUserAsync = async (token: string): Promise<any> => {
  const baseUrl = getApiBaseUrl();
  const apiUrl = `${baseUrl}/api/User/DeleteUserAsync`;

  try {
    const response = await fetch(apiUrl, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': '*/*',
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to delete user');
    }

    return await response.json();
  } catch (error) {
    // console.error('Error in DeleteUserAsync:', error);
    throw error;
  }
};